var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 10.001 14.001A7 7 0 007 0zm2.758 9.152l-.447.609a.125.125 0 01-.175.027L6.552 7.902a.124.124 0 01-.052-.101V3.5c0-.069.056-.125.125-.125h.752c.068 0 .125.056.125.125v3.867L9.73 8.978c.056.04.068.117.028.174z",
    fill: "currentColor"
  })));
}

export default SvgClockCircleFilled;